<div class="div_loading">
  <div class="my-container" [hidden]="!loading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>
<div class="login" style="background-color:#E2402B;height:100vh">
  <div class="login_page">
    <div class="login_form_wrap">
      <form name="mySendCodeForm" class="form">
        <div class="login_phone_groups_wrap clearfix">
          <div class="md-input-group login_phone_num_input_group md-input-animated">
            <input class="md-input" name="username" [(ngModel)]="username" type="text" placeholder='username'>
          </div>
        </div>

        <div class="login_phone_groups_wrap clearfix">
          <div class="md-input-group login_phone_num_input_group md-input-animated">
            <input class="md-input" name="password" [(ngModel)]="password" type="password" placeholder='password'>
          </div>
        </div>

        <div class='login-div'>
          <input type='submit' class='btn login-button' (click)="user_login()" value='Login'>
          <br>
        </div>

      </form>
      <div class="alert alert-danger" *ngIf='err_validation' style="text-align: center;">{{ err }}</div>
    </div>
  </div>
</div>